"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _withBasedRouter = _interopRequireDefault(require("@devsta/with-based-router"));

var _commonReact = require("@devsta/common-react");

var _reactApollo = require("react-apollo");

var _basePath = _interopRequireDefault(require("../../../common/constants/basePath"));

var _ManageCampaign = _interopRequireDefault(require("../components/ManageCampaign"));

var _api = require("../../../common/api");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ManageCampaign(_ref) {
  var history = _ref.history,
      match = _ref.match;
  var inspirationCampaignId = match.params.id;
  return _react.default.createElement(_commonReact.RequestProvider, {
    requests: {
      getInspirationCampaign: (0, _api.getInspirationCampaignApi)({
        inspirationCampaignId: inspirationCampaignId
      }),
      getInspirationCampaignPosts: (0, _api.getInspirationPostsForCampaignApi)(inspirationCampaignId),
      updateCampaign: (0, _api.updateCampaignApi)(inspirationCampaignId),
      updateInspiration: (0, _api.updateInspirationApi)()
    }
  }, function (requests) {
    return _react.default.createElement(_reactApollo.ApolloConsumer, null, function (apiClient) {
      return _react.default.createElement(_ManageCampaign.default, _extends({
        history: history,
        campaignId: inspirationCampaignId,
        apiClient: apiClient
      }, requests));
    });
  });
}

var _default = (0, _withBasedRouter.default)(_basePath.default, ManageCampaign);

exports.default = _default;